import { connectFirestoreEmulator, getFirestore, type Firestore } from 'firebase/firestore';
import { getApp } from './app';
import { EMULATOR_HOST, EMULATOR_PORTS, emulatorsEnabled } from './emulator';

/**
 * Instance `Firestore` PARTAGÉE. Câble l'émulateur UNE fois si activé. Côté
 * client, Firestore n'est lu en direct que pour des données PUBLIQUES (barème) ;
 * tout le reste passe par des callables gatées.
 */

let cached: Firestore | null = null;

export function getDb(): Firestore | null {
  const app = getApp();
  if (app === null) return null;
  if (cached !== null) return cached;
  cached = getFirestore(app);
  if (emulatorsEnabled()) {
    connectFirestoreEmulator(cached, EMULATOR_HOST, EMULATOR_PORTS.firestore);
  }
  return cached;
}
